import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";
import { DataLayerService } from "../../services/DataLayerService";

export class RewardsInfographic extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);

		this.applyDataLayerCtaEvent();
	}

	applyDataLayerCtaEvent(): void {
		const selector = ".cta-click";
		const elements = this._element.querySelectorAll(selector);

		if (!elements) {
			console.warn("No elements found for selector", selector);
			return;
		}

		elements.forEach(element => {
			element.addEventListener("click", e => {
				const evtModel = {
					module_name: "RewardsInfographic",
					link_category: "CFA One",
					link_text: element.innerHTML || "Join the program"
				};
				DataLayerService.pushDataLayerEvent("cta_click", evtModel);
			});
		});
	}
}

ComponentFactory.registerComponent("RewardsInfographic", RewardsInfographic);
